<template>
  <div class="tree-view-element">
    <template v-for="(catData, catName) in $store.state.roleTreeData">
      <div class="tree-root" @click="toggleExpand">
        <i v-if="!expanded" class="fas fa-plus"></i>
        <i v-else class="fas fa-minus"></i>
        <span class="font14">{{ catName }}</span>
      </div>
      <!-- <ul v-show="expanded">
        <li v-for="item in elem.items" :key="item.toString()">
          <span @click="addItem(item.name)">{{ item.display }}</span>
        </li>
      </ul> -->
    </template>
  </div>
</template>

<script>
export default {
  name: 'tree-view',

  data () {
    return {
      expanded: false
    }
  },

  props: {
    isChild: {
      type: Boolean,
      default: false
    },

    isParent: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    if (!Object.keys(this.$store.state.roleTreeData).length) this.processData()
  },

  methods: {
    toggleExpand () {
      this.expanded = !this.expanded
    },

    addItem (item) {
      this.$parent.$emit('addItem', item)
    },

    processData () {
      let treeData = {}
      let modelData = JSON.parse(JSON.stringify(this.$store.state.models))
      modelData.forEach(model => {
        if (typeof treeData[model.category] === 'undefined') treeData[model.category] = {items: [], subname: '', subItems: []}
        if (model.subcategory !== undefined) {
          if (model.subcategory.length) {
            treeData[model.category].subname = model.subcategory
          }
        }
        const newItem = {
          prefix: model.prefix,
          type: model.type,
          field: model.field,
          label: model.label,
          properties: model.properties,
          route: model.route,
          command: model.command
        }

        if (model.subcategory !== undefined) {
          if (model.subcategory.length) {
            treeData[model.category].subItems.push(newItem)
          }
        } else treeData[model.category].items.push(newItem)
      })
      this.$store.commit('setRoleTreeData', treeData)
    }
  }
}
</script>


<style lang="scss" scoped>
  .font14{
    font-size: 14px;
  }
  .tree-root {
    cursor: pointer;
    user-select: none;
    &:hover > span {
      text-decoration: underline;
    }

    i {
      border: 1px solid black;
      padding: 3px;
    }

    span {
      margin-left: 10px;
      font-weight: bold;
    }
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      cursor: pointer;

      &:hover > span {
        text-decoration: underline;
      }

      &:before {
        content: '∟';
        margin-left: 5px;
        font-weight: bold;
        font-size: 18px;
        line-height: 18px;
      }
    }
  }

</style>





// WEBPACK FOOTER //
// src/components/editor/modal-edit/TreeView.vue